module.exports = __webpack_public_path__ + "media/images/front/sp/features/search/doctors/icon_arrow_right-5d39cdab022ac0ae3ca157497633edc9.svg";